import { useState, useEffect } from 'react'

// Components
import { Error, Heading, Entity, Shelf } from '@tracklib/kit'
import Cover from 'components/collection/cover'
import PlayButton from 'components/playbutton'

// Types
import { ApiRequest, Collection, Artist, TrackList } from 'types'

import styles from './recommendations.css'

type RecommendationsProps = {
  recommendedCollections: Array<Collection>
  recommendedArtists: Array<Artist>
  recommendedTracks: TrackList
  renderTrackList: (trackList?: TrackList, fakeTrackList?: Array<number>, preventOnlySpecificTrackName?: boolean) => void
  request: ApiRequest
}

const Recommendations = ({
  recommendedTracks,
  recommendedCollections,
  recommendedArtists,
  renderTrackList,
  request,
}: RecommendationsProps) => {
  const [rec, setRecommendations] = useState<Array<JSX.Element>>([])
  const recCol = recommendedCollections.map((collection, index) => {
    const { title, id } = collection
    return (
      <Entity
        key={`col-${String(index)}`}
        title={title}
        image={<Cover collection={collection} />}
        backgroundColor="transparent"
        url={`/collection/${id}/`}
        type="Collection"
        size={5}
        hoverComponent={<PlayButton entity="collection" value={String(id)} contextKey={`collection-${id}`} hoverOnly />}
      />
    )
  })

  const recArt = recommendedArtists.map((a, index) => (
    <Entity
      key={`art-${String(index)}`}
      title={a.name}
      url={`/artist/${a.slug}/`}
      type="Artist"
      image={a.image?.uri}
      size={5}
      hoverComponent={<PlayButton entity="artist" value={a.slug} hoverOnly />}
    />
  ))

  useEffect(() => {
    const recommendations = recCol
      .concat(recArt)
      .sort(() => (Math.random() > 0.5 ? 1 : -1))
      .slice(0, 5)
    setRecommendations(recommendations)
  }, [recCol.length, recArt.length]) // eslint-disable-line

  return (
    <div className={styles.container} datatesting="recommendations_container">
      <Heading datatesting="recommended_header">Keep digging</Heading>
      {request.isDone && rec.length < 5 && !recommendedTracks.length && (
        <Error message="No recommendations found" replacePageTitle={false} />
      )}
      <Shelf className={styles.shelfWrapper}>
        {!request.isDone
          ? [1, 2, 3, 4, 5].map(id => (
              <Shelf.Item key={id}>
                <Entity url="/" title="" loading />
              </Shelf.Item>
            ))
          : rec.map((r, i) => <Shelf.Item key={String(i)}>{r}</Shelf.Item>)}
      </Shelf>
      {renderTrackList(recommendedTracks.length ? recommendedTracks : undefined, [1, 2, 3, 4, 5], true)}
    </div>
  )
}

export default Recommendations
